import React, { useEffect, useMemo, useState } from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";

const PLACEHOLDER_PATTERN = /\[(\d*)\]/g;

const HtmlPart = ({ html }) => (
  <span
    className="input-question-html-part"
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

const parseQuestionParts = (text) => {
  const source = String(text || "");
  const parts = [];
  const sizes = [];
  let lastIndex = 0;
  let match;

  PLACEHOLDER_PATTERN.lastIndex = 0;
  while ((match = PLACEHOLDER_PATTERN.exec(source)) !== null) {
    parts.push(source.slice(lastIndex, match.index));
    sizes.push(match[1] ? Number(match[1]) : null);
    lastIndex = match.index + match[0].length;
  }

  parts.push(source.slice(lastIndex));
  return { parts, sizes };
};

const InputQuestion = ({
  question,
  questionKey,
  onInputsChange,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  const parsed = useMemo(() => parseQuestionParts(question), [question]);
  const parts = parsed.parts;
  const inputSizes = parsed.sizes;
  const inputCount = inputSizes.length;
  const [values, setValues] = useState(() => Array.from({ length: inputCount }, () => ""));

  useEffect(() => {
    const nextValues = Array.from({ length: inputCount }, () => "");
    setValues(nextValues);
    onInputsChange(nextValues, false);
  }, [inputCount, onInputsChange, question, questionKey]);

  function updateValue(idx, value) {
    const nextValues = values.map((item, i) => (i === idx ? value : item));
    setValues(nextValues);
    onInputsChange(nextValues, nextValues.every((item) => item.trim().length > 0));
  }

  return (
    <>
      <div className="input-question">
        {parts.map((part, idx) => (
          <React.Fragment key={`${questionKey || "input"}-${idx}`}>
            <HtmlPart html={part} />
            {idx < inputCount && (
              <input
                className="input-question-blank"
                style={
                  inputSizes[idx]
                    ? {
                      "--input-blank-width": `calc(${inputSizes[idx]}ch + 28px)`,
                      "--input-blank-min-width": "42px",
                    }
                    : undefined
                }
                value={values[idx] || ""}
                onChange={(e) => updateValue(idx, e.target.value)}
                aria-label={`Пропущене слово ${idx + 1}`}
              />
            )}
          </React.Fragment>
        ))}
      </div>

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default InputQuestion;
